module.exports = __webpack_public_path__ + "img/icon-error.a7938aec.svg";